/* eslint-disable no-console */
type LogLevel = 'info' | 'debug';

const LOG_LEVEL: LogLevel =
  process.env.LOG_LEVEL === 'debug' ? 'debug' : 'info';

/**
 * TODO: This should be replaced by an appropriate logging solution.
 *  For now, this is better than sprinkling console.log() throughout the codebase
 */
export function log(message: any) {
  console.log(message);
}

/**
 * Log an error!
 *  Also see / consider @sentry/react captureException()
 */
export function logError(message: any) {
  console.error(message);
}

/**
 * Add debug logs without fear of muddying up logs unless you opt-in via LOG_LEVEL in .env
 */
export function logDebug(message: any) {
  if (LOG_LEVEL === 'debug') {
    log(message);
  }
}
